import TopBar from "../../components/topBar/topBar";
import { useState } from 'react';
import { getCitation } from "../../helpers/citation.helper";
import { getFormAuthors } from "../../helpers/authors.helper";
import { getKeywords } from "../../helpers/keywords.helper";
import { apiClient } from "../../api/apiClient";
import { validateStudyForm } from "../../validators/validateStudyForm";

function StudyForm({ setPageState, setSuccess }) {
    const [formValues, setFormValues] = useState({
        title: '',
        parent_article: '',
        parent_author: '',
        city: '',
        year: '',
        publisher: '',
        pageFrom: 0,
        pageTo: 0,
        isbn: '',
        citation_type: 4,
    })

    const [formErrors, setFormErrors] = useState({});
    const [authors, setAuthors] = useState('');
    const [keywords, setKeywords] = useState('');

    async function handleSubmit() {
        const validation = validateStudyForm({ ...formValues, authors });

        console.log(validation);

        if (validation == true) {
            // Good stuff
            const finalBody = {
                ...formValues, authors: getFormAuthors(authors), keywords: getKeywords(keywords)
            }

            const req = await apiClient.post(`/book`, finalBody);
            if (req.status == 200) {
                console.log('Book added');
                setFormValues({
                    title: '',
                    city: '',
                    year: '',
                    parent_article: '',
                    publisher: '',
                    pageFrom: 0,
                    pageTo: 0,
                    isbn: '',
                    citation_type: 4,
                });
                setAuthors('');
                setKeywords('');
                setPageState(0);
                setSuccess(true);
            } else {
                console.log(req);
            }

            console.log(finalBody);
        } else {
            setFormErrors(validation);
        }
    }

    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-2xl px-4 sm:px-6 py-10">

                <button
                    type="button"
                    onClick={() => setPageState(0)}
                    className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
                >
                    <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Go Back
                </button>

                <h1 className="mb-8 text-2xl font-light text-mainDark">Nová štúdia</h1>

                <div className="flex flex-col gap-5">
                    <div className="w-full">
                        <label htmlFor="title" className="block text-base font-medium ml-3 text-mainBlue pb-2">Title</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, title: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.title}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="author" className="block text-base font-medium ml-3 text-mainBlue pb-0">Authors</label>
                        <p className='ml-3 text-sm text-mainDark italic font-thin'>Meno Priezvisko - Meno Priezvisko - Meno Priezvisko</p>
                        <input type="text" className='formInput' onChange={e => setAuthors(e.target.value)} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.authors}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="city" className="block text-base font-medium ml-3 text-mainBlue pb-2">City</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, city: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.city}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="parent_article" className="block text-base font-medium ml-3 text-mainBlue pb-2">Parent article</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, parent_article: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.parent_article}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="parent_author" className="block text-base font-medium ml-3 text-mainBlue pb-2">Parent author</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, parent_author: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.parent_author}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="year" className="block text-base font-medium ml-3 text-mainBlue pb-2">Year</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, year: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.year}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="publisher" className="block text-base font-medium ml-3 text-mainBlue pb-2">Publisher</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, publisher: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.publisher}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="pageFrom" className="block text-base font-medium ml-3 text-mainBlue pb-2">Page From</label>
                        <input type="number" className='formInput' onChange={e => setFormValues(values => ({ ...values, pageFrom: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.pageFrom}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="pageTo" className="block text-base font-medium ml-3 text-mainBlue pb-2">Page To</label>
                        <input type="number" className='formInput' onChange={e => setFormValues(values => ({ ...values, pageTo: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.pageTo}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="isbn" className="block text-base font-medium ml-3 text-mainBlue pb-2">ISBN/ISSN</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, isbn: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.isbn}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="keywords" className="block text-base font-medium ml-3 text-mainBlue pb-2">Keywords</label>
                        <p className='ml-3 text-sm text-mainDark italic font-thin'>Keyword, Keyword, Keyword, ...</p>
                        <input type="text" className='formInput' onChange={e => setKeywords(e.target.value)} />
                    </div>

                    {validateStudyForm({ ...formValues, authors }) == true && (
                        <div className="rounded-2xl border border-mainDark/30 bg-mainWhite p-5 shadow-result">
                            <p className="text-[10px] uppercase tracking-widest font-medium text-mainBlue mb-3">Citation preview</p>
                            <p className="text-sm text-mainDark/70 font-light leading-relaxed" dangerouslySetInnerHTML={{ __html: getCitation({ ...formValues, authors: getFormAuthors(authors) }) }} />
                        </div>
                    )}

                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full rounded-3xl bg-primary py-4 text-onPrimary shadow-search transition-all duration-200 hover:brightness-110 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,0,0,0.25)] active:translate-y-0 active:brightness-95"
                    >
                        SUBMIT
                    </button>
                </div>

            </div>
        </div>
    );
}

export default StudyForm;
